import 'bootstrap/dist/css/bootstrap.min.css';
import NavbarComp from './Components/NavbarComp';
import MayBeShowNavBar from './Components/MayBeShowNavBar';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Redirections from './Pages/Redirections';
import NewRedirection from './Pages/NewRedirection';
import ModificationRedirection from './Pages/ModificationRedirection';
import ChangePassword from './Pages/ChangePassword';
import Login from './Pages//Login';
import Users from './Pages/Users';
import NewUser from './Pages/NewUser';
import ModificationUser from './Pages/ModificationUser';
import ErrorPage from './Pages/ErrorPage';
import DocumentNotFound from './Pages/DocumentNotFound';


function App() {

  const isAdmin = (sessionStorage.getItem("role") === "admin");
  const isUser = (sessionStorage.getItem("role") === "user");
  const isLogged = (isAdmin || isUser);

  return (
    <div className="App">
      <Router>
        <MayBeShowNavBar>
          <NavbarComp />
        </MayBeShowNavBar>
        <Routes>
          <Route path="/users" element={(isAdmin) ? <Users /> : <ErrorPage />} />
          <Route path="/newuser" element={(isAdmin) ? <NewUser /> : <ErrorPage />} />
          <Route path="/modificationuser/:token" element={(isAdmin) ? <ModificationUser /> : <ErrorPage />} />
          <Route path="/changepassword" element={(isLogged) ? <ChangePassword /> : <ErrorPage />} />
          <Route path="/newredirection" element={(isLogged) ? <NewRedirection /> : <ErrorPage />} />
          <Route path="/modificationredirection/:token" element={(isLogged) ? <ModificationRedirection /> : <ErrorPage />} />
          <Route path="/redirections" element={(isLogged) ? <Redirections /> : <ErrorPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Login />} />
          <Route path="/documentnotfound" element={<DocumentNotFound />} />
        </Routes>
      </Router >

    </div>
  );
}

export default App;
